import { http, HttpResponse } from 'msw'

import { user } from '@/mocks/data/general/user'

import { api } from '@/utils/constants'

import { User } from '@/types/user'

export const deletePrivateCard = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.account.konvives.DELETE_PRIVATE_CARD}`,
    () => {
        return HttpResponse.json<User>(user)
    },
)
